import { createRoot } from 'react-dom/client';
import 'swiper/swiper-bundle.css';

import 'common/api/axios-interceptor';

import { RouteComponent } from '../routes/Route.component';
import '../styles/index.css';

try {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => {
        if (reg.scope.includes('/platform/')) {
          reg.unregister().then(() => {
            window.location.reload(); // Optional
          });
        }
      });
    });
  }
} catch (error) {
  console.warn(error);
}

const initReact = () => {
  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(
    // TODO: Doesn't work with current version of react-router. Need to upgrade to react-router@6
    // <StrictMode>
    <RouteComponent />,
    // </StrictMode>
  );
};

initReact();
